import script from "./CardData.vue?vue&type=script&setup=true&lang=js"
export * from "./CardData.vue?vue&type=script&setup=true&lang=js"

import "./CardData.vue?vue&type=style&index=0&id=b5b30402&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5b30402"]])

export default __exports__